import { toast } from 'react-toastify';
import { createAndSendSms } from 'services/api/notifications/createAndSendSms';
import { sendTestSms } from 'services/api/notifications/sendTestSms';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toastOptions } from 'helpers/colorConstants';
import { NOTIFICATIONS_KEY } from 'constants/TanStackKeys';

export const useCreateNotificationMutation = (closeModal) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: createAndSendSms,
		onSuccess: (data) => {
			if (!data || data.error) {
				// Validation errors come with the API message; network or server
				// errors only with the axios message.
				toast.error(
					data?.data?.response_description ||
						(typeof data?.data === 'string' && data.data) ||
						'Error creating notification',
					toastOptions,
				);
				return;
			}

			queryClient.invalidateQueries({
				queryKey: [NOTIFICATIONS_KEY],
			});
			if (closeModal) {
				closeModal();
			}
			toast.success(
				`Notification queued: sending to ${data.total_recipients.toLocaleString()} members`,
				toastOptions,
			);
		},
		onError: (error) => {
			const errorMessage =
				error?.message ||
				error?.data?.response_description ||
				'Error creating notification';
			toast.error(errorMessage, toastOptions);
		},
	});
};

export const useSendTestSmsMutation = (onSuccessCallback) => {
	return useMutation({
		mutationFn: sendTestSms,
		onSuccess: (data) => {
			if (data && data.error) {
				toast.error(
					data?.data?.response_description || 'Error sending test SMS',
					toastOptions,
				);
			}
			if (data && !data.error) {
				toast.success(
					data?.data?.status || 'Test SMS sent successfully',
					toastOptions,
				);
				if (onSuccessCallback) onSuccessCallback(data);
			}
		},
		onError: (error) => {
			const errorMessage =
				error?.message ||
				error?.data?.response_description ||
				'Error sending test SMS';
			toast.error(errorMessage, toastOptions);
		},
	});
};
